import React, { useState, useEffect } from "react";
import DashboardApi from "../../Api/DashboardApi";

const formatDateDisplay = (dateStr) => {
    if (!dateStr) return "";
    const parts = dateStr.split("-").map(Number);
    if (parts.length === 3) {
        const d = new Date(parts[0], parts[1] - 1, parts[2]);
        return d.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
    }
    return dateStr;
};

const TopCustomersTable = ({ filter, date }) => {
    const [customers, setCustomers] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchTopCustomers();
    }, [filter, date]);

    const fetchTopCustomers = async () => {
        setLoading(true);
        try {
            const res = await DashboardApi.getTopCustomers(filter, date);
            if (res.status && res.response.data) {
                setCustomers(res.response.data);
            } else {
                setCustomers([]);
            }
        } catch (error) {
            console.error("Error fetching top customers:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="card radius-12 border-0 shadow-sm">
            <div className="card-header border-bottom bg-base py-16 px-24">
                <h6 className="text-lg fw-semibold mb-0">
                    Top 5 Purchase Customers - {filter === "Day" && date ? `Day (${formatDateDisplay(date)})` : filter}
                </h6>
            </div>
            <div className="card-body p-0">
                <div className="table-responsive">
                    <table className="table margin-0-important mb-0">
                        <thead className="bg-light">
                            <tr>
                                <th className="px-24">Customer</th>
                                <th>Total Purchase</th>
                                <th>Orders</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                Array.from({ length: 5 }).map((_, i) => (
                                    <tr key={i}>
                                        <td className="px-24"><div className="skeleton-line w-75 bg-light py-10 radius-4"></div></td>
                                        <td><div className="skeleton-line w-50 bg-light py-10 radius-4"></div></td>
                                        <td><div className="skeleton-line w-25 bg-light py-10 radius-4"></div></td>
                                    </tr>
                                ))
                            ) : customers.length > 0 ? (
                                customers.map((c, i) => (
                                    <tr key={i}>
                                        <td className="px-24">
                                            <div className="d-flex flex-column">
                                                <span className="fw-semibold text-secondary-light">{c.customerName || "Unknown"}</span>
                                                <small className="text-muted">{c.phoneNumber}</small>
                                            </div>
                                        </td>
                                        <td>₹{c.totalPurchase.toLocaleString("en-IN")}</td>
                                        <td>{c.ordersCount}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="3" className="text-center py-4 text-secondary-light">
                                        No data available for this period
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default TopCustomersTable;
